export const COMMON_RESET_STATE = 'COMMON_RESET_STATE';

export const commonResetState = () => ({
  type: COMMON_RESET_STATE,
});
